import { Link, NavLink } from "react-router-dom";
import { ROUTES } from "../../../constants/_routes";
import ProfileIcon from "../Icons/ProfileIcon";
import AboutIcon from "../Icons/AboutIcon";
import TermsIcon from "../Icons/TermsIcon";
import ContactUsIcon from "../Icons/ContactUsIcon";
import SignOutIcon from "../Icons/SignOutIcon";
import LanguageBtn from "../../Common/LanguageBtn/LanguageBtn";

export function buildMoreDropdownItems({
  dir,
  t,
  isEmirates,
  handleCloseMenu,
  setShowProfileDrawer,
  setIsTermsModalOpen,
  handleContact,
}) {
  return [
    {
      key: 0,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <button
            type="button"
            onClick={() => setShowProfileDrawer(true)}
            className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex gap-2 gap-md-1 align-items-center"
          >
            <ProfileIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.profile")}
            </span>
          </button>
        </li>
      ),
    },
    {
      key: 1,
      label: (
        <>
          {!isEmirates && (
            <li className="nav-item">
              <NavLink
                to={ROUTES.ABOUT}
                dir={dir}
                className="nav-link p-0 text-decoration-none d-flex gap-2 gap-md-1 align-items-center"
              >
                <AboutIcon />
                <span className="recycle-nav__nav-titles text-center fsize-12">
                  {t("nav.about")}
                </span>
              </NavLink>
            </li>
          )}
        </>
      ),
    },
    ...(!isEmirates
      ? [
          {
            key: 2,
            label: (
              <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
                <button
                  type="button"
                  onClick={() => setIsTermsModalOpen(true)}
                  className="w-100 p-0 bg-transparent border-0 outline-none shadow-none d-flex gap-2 gap-md-1 align-items-center"
                >
                  <TermsIcon />
                  <span className="recycle-nav__nav-titles text-center fsize-12">
                    {t("nav.terms")}
                  </span>
                </button>
              </li>
            ),
          },
        ]
      : []),
    {
      key: 3,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <Link
            to={"#"}
            onClick={handleContact}
            className="nav-link p-0 d-flex gap-2 gap-md-1 align-items-center"
          >
            <ContactUsIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.contactUs")}
            </span>
          </Link>
        </li>
      ),
    },
    {
      key: 4,
      label: (
        <li dir={dir} className="nav-item" onClick={handleCloseMenu}>
          <LanguageBtn inNavMoreMenu />
        </li>
      ),
    },
    {
      key: 5,
      label: (
        <li dir={dir} className="nav-item">
          <Link
            to={ROUTES.LOGOUT}
            className="nav-link p-0 d-flex gap-2 gap-md-1 align-items-center"
          >
            <SignOutIcon />
            <span className="recycle-nav__nav-titles text-center fsize-12">
              {t("nav.signout")}
            </span>
          </Link>
        </li>
      ),
    },
  ];
}
